exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uk-block-primary[data-v-4090dcc6] {\n  background-color: #dfeaff;\n}\n.uk-block-primary .title[data-v-4090dcc6] {\n  font-size: 2em;\n}\n.uk-block-primary .owner-information .organization-name[data-v-4090dcc6] {\n  font-size: 1em;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n.uk-block-primary .owner-information .person-name[data-v-4090dcc6] {\n  font-size: 1.4em;\n  margin-bottom: 8px;\n}\n.uk-block-primary .owner-information .person-address[data-v-4090dcc6] {\n  font-size: 1.2em;\n}", ""]);

// exports
